import config from '@/config.js'
import axios from '@/axios.js'

const type = {
  mutations: {
    mutate_getUserInfo: 'mutate_getUserInfo',
    mutate_login: 'mutate_login'
  },
  getters: {
  },
  actions: {
    getUserInfo: 'getUserInfo',
    login: 'login'
  }
}

const state = {
  userInfo: {}
}
const getters = {
}
const mutations = {
  [type.mutations.mutate_getUserInfo] (state, v) {
    state.userInfo = v
  },
  [type.mutations.mutate_login] (state, v) {
    localStorage.setItem('auth', v)
    state.userInfo = v
  }
}
const actions = {
  [type.actions.getUserInfo] (context, v) {
    let suc = v.success
    v.success = function (data) {
      context.commit(type.mutations.mutate_getUserInfo, data)
      suc && suc()
    }
    return axios.post(config.API.Controller.user.getUserInfo, v)
  },
  [type.actions.login] (context, v) {
    let suc = v.success
    v.success = function (data) {
      context.commit(type.mutations.mutate_login, data)
      suc && suc()
    }
    return axios.post(config.API.Controller.user.login, v)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
export const TYPE = type
